

import React, {Component} from 'react';
import {Switch, Route, withRouter, MemoryRouter} from "react-router-dom";

import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import LoginPage from "./pages/LoginPage";
import UserConsent from './pages/logicals/UserConsent';
import TokenService from './API/token/TokenService';
import PropTypes from 'prop-types';
import {getLoggedInUser, setLoggedInUser, storeChallengeInCookie, isUserAuthenticated} from './API/Cookie';
import {challenge} from './API/CodeChallange';
import Loading from './pages/Loading';
import Login from './pages/auth/Login';
import Otp from './pages/auth/Otp';
import Register from './pages/auth/Register';
import ResetPassword from './pages/auth/ResetPassword';
import ResetPasswordEmail from './pages/auth/ResetPasswordEmail';
import ResetPasswordNew from './pages/auth/ResetPasswordNew';
import Verify from './pages/auth/Verify';
import LandingPage from './pages/LandingPage';
import ConsentSuccess from './pages/logicals/ConsentSuccess';


class App extends Component {

    constructor(props) {
        super();
        this.state = {
            data: [],
            isLoading: true,
            loggedIn: false,
            token: '',
            user: {}
        }
    }
    static contextTypes = {
        decrypt: PropTypes.func.isRequired,
    };

    componentDidMount() {
        const userString = localStorage?.getItem('UserData');
        // const decryptedData = userString && this.context.decrypt(userString);
        let user;
        try {
            user = JSON.parse(userString)
        } catch (e) {
            localStorage.removeItem("UserData")
        }
        if (user) {
            TokenService.verifyToken(user.accessToken)
                .then((res) => {
                    this.setState({isLoading: false, loggedIn: true, user: user});
                    setLoggedInUser({user: {user: user}, accessToken: res?.data?.accessToken});
                })
                .catch((err) => {
                    this.setState({isLoading: false, loggedIn: false, token: user.accessToken});
                })
        } else {
            this.setState({isLoading: false, loggedIn: false});
        }
    }


    render() {
        //console.log(this.state.user)
        return (
            <div className="App">

                {this.state.loggedIn === true && !this.state.isLoading ?
                    <Switch>
                        <Route exact path="/">
                            <UserConsent user={this.state.user} />
                        </Route>
                        <Route path="/success" exact >
                            <ConsentSuccess />
                        </Route>
                    </Switch>
                    : !this.state.isLoading ?
                        <Switch>
                            <Route path="/" exact >
                                <LandingPage />
                            </Route>

                            <Route path="/landing" exact >
                                <LoginPage />
                            </Route>
                            <Route path="/register" exact>
                                <Register setIsLoggedIn={this.setState} />
                            </Route>
                            <Route path="/login">
                                <Login setIsLoggedIn={this.setState} {...this.props} />
                            </Route>
                            <Route path="/reset">
                                <ResetPassword setIsLoggedIn={this.setState} {...this.props} />
                            </Route>
                            <Route path="/resetotp">
                                <ResetPasswordEmail setIsLoggedIn={this.setState} {...this.props} />
                            </Route>
                            <Route path="/resetnew">
                                <ResetPasswordNew setIsLoggedIn={this.setState} {...this.props} />
                            </Route>
                            <Route path="/verify">
                                <Verify setIsLoggedIn={this.setState} {...this.props} />
                            </Route>
                            <Route path="/otp">
                                <Otp setIsLoggedIn={this.setState} {...this.props} />
                            </Route>
                            {/*  <Redirect from="*" to="/" />*/}
                        </Switch> : <Switch>
                            <Route path="/" exact >
                                <Loading />
                            </Route>

                        </Switch>

                }
            </div>


        );
    }

}

export default withRouter(App);
